module.exports = __webpack_public_path__ + "static/media/add class discipline.7803052d.svg";